import jquery from 'jquery';
import EFOcats_submit from '../../../core/v2/submit/efocats_submit.js';

/**
 * データ送信機能
 */
export default class EFOcats_iwatani_submit extends EFOcats_submit {
  constructor() {
    super();
    this.analy_time_access = null;
    this.all_time = 0;
  }

  /**
   * 初期化
   */
  initialize() {
    this.form_data.post = {};
    this.form_data.analytics = {};
    this.form_data.ID = efocats.account.id;
    this.form_data.formID = efocats.account.form_id;

    this.meta();
    this.$('input[type="hidden"]').each((index, element) => {
      if (jquery(element).closest('.hidden-area').length <= 0) {
        this.form_data[jquery(element).attr('name')] = jquery(element).val();
      }
    });

    // 項目作成
    this.data_label_first();

    // 新規・再訪の確認
    this.visited();
  }

  /**
   * 全体の処理時間セット
   */
  time_all() {
    this.stop_time_all();
    const time_stamp = this.make_timestamp(this.all_time);
    this.analy_data.time = time_stamp;
  }

  /**
   * 全体の処理時間計測開始
   */
  start_time_all() {
    if (this.analy_time_access == null) {
      this.analy_time_access = new Date();
    }
  }

  /**
   * 全体の処理時間計測停止
   */
  stop_time_all() {
    if (this.analy_time_access != null) {
      const analy_time_leave = new Date();
      const time = Math.floor((analy_time_leave.getTime() - this.analy_time_access.getTime()) / 1000);
      this.all_time += time;
      this.analy_time_access = null;
    }
  }

  /**
   * ステータス（個別）
   */
  status_individual(obj) {
    let status;
    const target = obj.parents('.qa');
    let val = true;

    // 必須項目取得
    const checks = target.find('.inner:hidden .check-flag.required');

    for (let index = 0; index < checks.length; index++) {
      const check = checks.eq(index);

      // 入力欄取得
      const inputs = check.find('input,select,textarea');

      for (let index2 = 0; index2 < inputs.length; index2++) {
        const input = inputs.eq(index2);
        const type = input.attr('type');
        const name = input.attr('name');

        // 必須項目で値が入ってないものがあればNo_input
        if (type === 'radio' || type === 'checkbox') {
          if (check.find(`input[name="${name}"]:checked`).length === 0) {
            val = false;
            break;
          }
        } else if (!input.val()) {
          val = false;
          break;
        }
      }

      if (!val) {
        break;
      }
    }

    if (val) {
      status = 'input_cmp';
    } else {
      status = 'No_input';
    }

    const index = this.$('.qa').index(target);
    this.analy_data.labeldata[index].status = status;
  }

  /**
   * 一問一答の処理（チェックボックスとラジオ以外）
   * @param {*} formName
   */
  create_answer_other(formName, inputelem) {
    if (formName === 'zip01') {
      jquery(`[name="zip01"]`).val(this.$(`[name="zip01"]`).val().substr(0, 3));
      jquery(`[name="zip02"]`).val(this.$(`[name="zip01"]`).val().substr(3, 4));
    } else if (formName === 'tel01') {
      const tel_num = this.getFormatPhone(this.$(`[name="${formName}"]`).val());

      if (tel_num) {
        const tel_num_list = tel_num.split('-');
        jquery(`[name="${formName}"]`)
          .parents('td')
          .find("input[type='text']")
          .each((index, element) => {
            if (tel_num_list[index]) {
              jquery(element).val(tel_num_list[index]);
            }
          });
      }
    } else if (formName === 'pref') {
      const opts = jquery(`select[name=${formName}]`).children('option');
      for (let index = 0; index < opts.length; index++) {
        const opt = opts.eq(index);
        if (opt.text() === this.$(`[name="${formName}"]`).val()) {
          jquery(`select[name=${formName}]`).val(opt.val());
        }
      }
    } else {
      super.create_answer_other(formName, inputelem);
    }
  }

  /**
   * 一問一答の処理（チェックボックス）
   * @param {*} formName
   * @param {*} inputelem
   */
  create_answer_checkbox(formName, inputelem) {
    if (formName === 'chk01') {
      jquery(`input[name="${formName}"]`).prop('checked', this.$(`input[name="${formName}"]`).prop('checked'));
    } else {
      super.create_answer_checkbox(formName, inputelem);
    }
  }

  /**
   * 項目作成
   */
  data_label_first() {
    this.$('.qa').each((index, element) => {
      const label = {};

      // 複数name修正（）
      label.title = jquery(element).find('.qaTitle').text();

      const inputs = jquery(element).find('input,textarea,select');

      label.name = '';

      for (let inputIndex = 0; inputIndex < inputs.length; inputIndex++) {
        const input = inputs.eq(inputIndex);
        if (input.attr('name')) {
          label.name = input.attr('name');
          break;
        }
      }

      // nameが取れない時はindexを入れておく
      if (label.name === '') {
        label.name = `dummyname${index}`;
      }

      label.error = [];
      label.status = this.data_label_first_status(inputs);
      label.time = 0;
      this.analy_data.labeldata.push(label);
    });
  }
}
